<template>
  <div class="sideFilters">
    <div
      class="header accent--text bt-accent"
      @click="show = !show"
    >Refinar Pesquisa <v-icon
        color="accent"
        small
        class="float-right"
      >{{ show ? 'fas fa-caret-down' : 'fas fa-caret-up' }}</v-icon>
    </div>
    <div v-if="show">
      <div class="mt-3">
        <v-radio-group
          dense
          :value="filter.idTipoPublicacao"
          label="Tipo de acervo"
          class="radio"
          @change="onSidebarFilter({idTipoPublicacao: $event});"
        >
          <v-radio
            v-for="col in collections"
            :key="col && col.id"
            :label="col.tipoPublicacao"
            :value="col.idTipopublicacao"
          ></v-radio>
        </v-radio-group>
      </div>
      <div class="mt-3">
        <v-radio-group
          dense
          label="Área"
          class="radio mt-0"
          :value="filter.idSegmento"
          @change="onSidebarFilter({idSegmento: $event})"
        >
          <v-radio
            v-for="seg in segmentosFiltered"
            :key="seg && seg.id"
            :label="seg && seg.segmento"
            :value="seg && seg.id"
            :class="seg && (seg.id === 423 || seg.id === 424) ? 'ml-10' : ''"
          ></v-radio>
        </v-radio-group>
      </div>
      <div>
        <v-radio-group
          dense
          label="Idioma"
          class="radio mt-0"
          @change="onSidebarFilter({
                                  idioma: {
                                    ...filter.idioma,
                                    idIdiomaPub: $event,
                                  }
                                })"
          :value="filter.idioma && filter.idioma.idIdiomaPub"
        >
          <v-radio
            v-for="id in idiomasFiltered"
            :key="id && id.id"
            :label="id.idioma"
            :value="id && id.id"
          ></v-radio>
        </v-radio-group>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    collections: {
      type: Array,
      default: () => [],
    },
    segmentos: {
      type: Array,
      default: () => [],
    },
    idiomas: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => {},
    },
    onSidebarFilter: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    if (window.innerWidth < 600) {
      this.show = false;
    }
  },
  computed: {
    idiomasFiltered() {
      if (this.idiomas && this.idiomas.length) {
        return this.idiomas.filter(idioma => idioma.idioma === 'Português' || idioma.idioma === 'Inglês');
      }
      return [];
    },
    segmentosFiltered() {
      if (this.segmentos && this.segmentos.length) {
        const { segmentos } = this;
        const copy = JSON.parse(JSON.stringify(segmentos));
        const tmp = copy.splice(8, 2);
        copy.splice(2, 0, tmp[0]);
        copy.splice(2, 0, tmp[1]);
        return copy;
      }
      return [];
    },
  },
};
</script>
<style scoped>
.sideFilters {
  margin-top: 5px;
}
.sideFilters .header {
  font-size: 12px;
  font-weight: bold;
  padding: 16px 0;
  cursor: pointer;
}
.sideFilters .radio >>> .v-input--radio-group__input > .v-label {
  font-size: 12px;
  font-weight: bold;
  color: #404040;
}
.sideFilters .radio >>> .v-input--radio-group__input .v-label {
  font-size: 12px;
}
.bt-accent {
  border-bottom: 1px solid #0399cc;
}
</style>
